<template>
    <v-card tile :loading="isLoadingPlannedTaskPhases">
        <!-- Planned task space -->
        <PlannedTaskSpaceChartDialog
            ref="plannedTaskSpaceChartDialogRef"
            :dialog.sync="plannedTaskSpaceChartDialog"
        ></PlannedTaskSpaceChartDialog>

        <!-- Add planned task dialog -->
        <PlannedTaskEditDialog
            ref="plannedTaskEditDialogRef"
            :dialog.sync="plannedTaskEditDialog"
            v-on:item-created="onPlannedTaskCreated"
        ></PlannedTaskEditDialog>

        <!-- Delete Plan Dialog -->
        <DeleteDialog
            :dialog.sync="deletePlannedTaskDialog"
            :item="deletingPlannedTask"
            v-on:confirmed="deletePlannedTaskConfirmed"
        >
            <template v-slot:title>Delete Plan</template>
            <template v-slot:content
                >Are you sure you want to delete this plan?
                <strong v-if="deletingPlannedTask.growthStartDate"
                    >{{ deletingPlannedTask.plant.name }} ({{
                        deletingPlannedTask.growthStartDate | moment("YYYY")
                    }}-w{{ deletingPlannedTask.growthStartDate | moment("w") }})
                    +{{ deletingPlannedTask.quantity }}</strong
                ></template
            >
        </DeleteDialog>

        <!-- Create growth task dialog -->
        <CreateGrowthTaskFromPlannedTaskDialog
            ref="createGrowthTaskFromPlannedTaskDialogRef"
            :dialog.sync="createGrowthTaskFromPlannedTaskDialog"
            v-on:item-created="onGrowthTaskCreated"
        >
        </CreateGrowthTaskFromPlannedTaskDialog>

        <!-- title -->
        <v-toolbar flat dark color="primary">
            <v-row align="center">
                <v-col
                    class="col-sm-3 col-md-4"
                    v-if="!$vuetify.breakpoint.xsOnly"
                >
                    <span v-if="title" class="title">{{ title }}</span>
                    <span v-if="totalSpaceM2" class="caption ml-2 pt-2"
                        >({{ totalSpaceM2 }} m2)
                    </span>
                </v-col>
                <v-col
                    class="col-8 col-sm-6 col-md-4"
                    align="center"
                    :class="$vuetify.breakpoint.xsOnly ? 'ml-2' : ''"
                >
                    <v-row align="center">
                        <v-text-field
                            :style="
                                $vuetify.breakpoint.xsOnly
                                    ? ''
                                    : 'max-width:50%'
                            "
                            dense
                            v-model="search"
                            :disabled="isLoadingPlannedTaskPhases"
                            label="Search"
                            clearable
                            hide-details
                            @keydown.enter="getPlannedTaskPhases()"
                            @click:clear="onClearSearch()"
                        ></v-text-field
                        ><v-spacer></v-spacer>
                        <v-switch
                            v-if="!$vuetify.breakpoint.xsOnly"
                            v-model="hideDoneTasks"
                            :disabled="isLoadingPlannedTaskPhases"
                            @change="onChangeHideDoneTasks()"
                            :label="
                                $vuetify.breakpoint.xsOnly ? '' : 'Hide Done'
                            "
                            class="ml-3 mt-0"
                            hide-details
                        ></v-switch
                    ></v-row>
                </v-col>
                <!-- <v-col cols="12" sm="2" align-self="start">
                <v-autocomplete
                    v-model="selectedGreenhouseDepartmentId"
                    :items="planFilterDepartmentList"
                    item-value="node.id"
                    item-text="node.name"
                    :disabled="isLoadingPlannedTaskPhases"
                    label="Department"
                    dense
                    clearable
                    hide-details
                >
                </v-autocomplete
            ></v-col>
            <v-col cols="12" sm="2" align-self="start">
                <v-autocomplete
                    v-model="selectedGreenhouseDepartmentSectionId"
                    :items="planFilterSectionList"
                    item-value="node.id"
                    item-text="node.name"
                    :disabled="isLoadingPlannedTaskPhases"
                    label="Sector"
                    dense
                    clearable
                    hide-details
                >
                </v-autocomplete
            ></v-col>
            <v-col cols="12" sm="2" align-self="start">
                <v-autocomplete
                    v-model="selectedWeek"
                    :items="weekList"
                    :disabled="isLoadingPlannedTaskPhases"
                    label="Week"
                    dense
                    clearable
                    hide-details
                >
                </v-autocomplete
            ></v-col> -->
                <v-col class="col-3 col-sm-3 col-md-4 pa-0" align="end">
                    <v-btn
                        icon
                        :loading="isLoadingPlannedTaskPhases"
                        @click="getPlannedTaskPhases()"
                        class="ma-0 pa-0"
                        style="height:36px; width:36px"
                        ><v-icon color="white">refresh</v-icon></v-btn
                    >
                    <v-btn
                        icon
                        @click="closePlannedTaskPhaseList()"
                        class="ma-0 pa-0"
                        style="height:36px; width:36px"
                        ><v-icon color="white">close</v-icon></v-btn
                    >
                </v-col>
            </v-row>
        </v-toolbar>
        <v-card-text class="mx-0 pa-0">
            <v-container fluid>
                <v-data-table
                    dense
                    fixed-header
                    :headers="headers"
                    :items="tenantPlannedTaskPhases.edges"
                    :options.sync="dataTableOptions"
                    :items-per-page="defaultItemsPerPage"
                    :server-items-length="tenantPlannedTaskPhases.totalCount"
                    :footer-props="{
                        'items-per-page-options': [10, 25, 50, 75, 100],
                        'disable-pagination': isLoadingPlannedTaskPhases
                    }"
                    loading-text="Loading... Please wait"
                >
                    <template v-slot:item.node.startDate="{ item }">
                        <span>{{
                            item.node.startDate | moment("YYYY-MM-DD ([W]WW)")
                        }}</span>
                    </template>
                    <template v-slot:item.node.endDate="{ item }">
                        <span
                            :class="
                                item.node.endInSelectedWeek ? 'red--text' : ''
                            "
                            >{{
                                item.node.endDate | moment("YYYY-MM-DD ([W]WW)")
                            }}</span
                        >
                    </template>
                    <template
                        v-slot:item.node.plannedTask.potSize.potSizeCm="{
                            item
                        }"
                    >
                        <span
                            >{{
                                item.node.plannedTask.potSize.potSizeCm
                            }}
                            cm</span
                        >
                    </template>

                    <template
                        v-slot:item.node.plannedTask.quantity="{
                            item
                        }"
                    >
                        <v-edit-dialog
                            :return-value.sync="item.node.plannedTask.quantity"
                            large
                            @save="onSavePlanQuantity(item.node.plannedTask)"
                            v-if="hasPermission('change_plannedtask')"
                        >
                            <span
                                v-if="item.node.phaseNo == 1"
                                class="primary--text"
                                >+{{ item.node.plannedTask.quantity }}
                            </span>
                            <span v-else class="primary--text"
                                >{{ item.node.plannedTask.quantity }}
                            </span>
                            <template v-slot:input>
                                <v-text-field
                                    v-model="item.node.plannedTask.quantity"
                                    label="Edit"
                                    type="number"
                                    single-line
                                ></v-text-field>
                            </template>
                        </v-edit-dialog>
                        <span v-else-if="item.node.phaseNo == 1"
                            >+{{ item.node.plannedTask.quantity }}
                        </span>
                        <span v-else
                            >{{ item.node.plannedTask.quantity }}
                        </span>
                    </template>
                    <template v-slot:item.node.phaseNo="{ item }">
                        <v-chip
                            class="my-1"
                            small
                            :color="
                                item.node.plannedTask.isDone
                                    ? 'warning'
                                    : 'warning'
                            "
                            v-if="item.node.isSalesPhase"
                            >Sales</v-chip
                        >
                        <v-chip
                            class="my-1"
                            small
                            dark
                            color="success"
                            v-else-if="item.node.phaseNo == 1"
                            >P{{ item.node.phaseNo }}</v-chip
                        >
                        <v-chip
                            class="my-1"
                            small
                            outlined
                            color="success"
                            v-else
                            >P{{ item.node.phaseNo }}</v-chip
                        >
                    </template>
                    <template v-slot:item.node.spaceM2="{ item }">
                        <span
                            :class="
                                item.node.endInSelectedWeek ? 'grey--text' : ''
                            "
                            >{{ item.node.spaceM2 }}</span
                        >
                    </template>
                    <template v-slot:item.action="{ item }">
                        <span>
                            <v-icon
                                small
                                class="mr-3"
                                :disabled="isLoadingPlannedTaskPhases"
                                @click="viewPlannedTask(item.node.plannedTask)"
                                >remove_red_eye</v-icon
                            >
                            <v-icon
                                v-if="hasPermission('change_plannedtask')"
                                small
                                class="mr-2"
                                :disabled="isLoadingPlannedTaskPhases"
                                @click="editPlannedTask(item.node.plannedTask)"
                                >edit</v-icon
                            >
                            <v-icon
                                v-if="hasPermission('delete_plannedtask')"
                                small
                                :disabled="isLoadingPlannedTaskPhases"
                                @click="
                                    onDeletingPlannedTask(item.node.plannedTask)
                                "
                                >delete
                            </v-icon>
                        </span>
                        <!-- <v-icon small @click="onDeletingTask(item.node)">delete</v-icon> -->
                    </template>
                    <template v-slot:item.node.plannedTask.isDone="{ item }">
                        <v-icon
                            v-if="item.node.plannedTask.isDone"
                            color="success"
                            >check_circle</v-icon
                        >
                        <v-btn
                            v-else-if="hasPermission('add_growthtask')"
                            x-small
                            outlined
                            rounded
                            :disabled="isLoadingPlannedTaskPhases"
                            @click="
                                openCreateGrowthTaskFromPlannedTask(
                                    item.node.plannedTask.id
                                )
                            "
                        >
                            Create
                        </v-btn>
                    </template>
                </v-data-table>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
import gql from "graphql-tag";
import helper from "@/utils/helper.js";
import moment from "moment";
import PlannedTaskSpaceChartDialog from "@/components/planner/PlannedTaskSpaceChartDialog.vue";
import PlannedTaskEditDialog from "@/components/planner/PlannedTaskEditDialog.vue";
import DeleteDialog from "@/components/base/DeleteDialog.vue";
import CreateGrowthTaskFromPlannedTaskDialog from "@/components/planner/CreateGrowthTaskFromPlannedTaskDialog.vue";

export default {
    name: "planned-task-phase-list",
    components: {
        PlannedTaskSpaceChartDialog,
        PlannedTaskEditDialog,
        DeleteDialog,
        CreateGrowthTaskFromPlannedTaskDialog
    },
    props: [
        "title",
        "totalSpaceM2",
        "initSelectedYear",
        "initSelectedWeek",
        "initSelectedGreenhouseId",
        "initSelectedGreenhouseDepartmentId",
        "initSelectedGreenhouseDepartmentSectionId",
        "initSelectedIsSalePhase",
        "selectedPlanFolderID",
        "selectedPlanFolderName"
    ],
    data() {
        return {
            plannedTaskSpaceChartDialog: false,
            plannedTaskEditDialog: false,
            deletePlannedTaskDialog: false,
            createGrowthTaskFromPlannedTaskDialog: false,
            isLoadingPlannedTaskPhases: false,

            weekList: [
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17,
                18,
                19,
                20,
                21,
                22,
                23,
                24,
                25,
                26,
                27,
                28,
                29,
                30,
                31,
                32,
                33,
                34,
                35,
                36,
                37,
                38,
                39,
                40,
                41,
                42,
                43,
                44,
                45,
                46,
                47,
                48,
                49,
                50,
                51,
                52,
                53
            ],
            // plan tasks list
            tenantPlannedTaskPhases: {},

            // filters
            selectedYear: this.initSelectedYear,
            selectedWeek: this.initSelectedWeek,
            selectedGreenhouseId: this.initSelectedGreenhouseId,
            selectedGreenhouseDepartmentId: this
                .initSelectedGreenhouseDepartmentId,
            selectedGreenhouseDepartmentSectionId: this
                .initSelectedGreenhouseDepartmentSectionId,
            selectedPhaseNo: null,
            selectedIsSalePhase: this.initSelectedIsSalePhase,
            hideDoneTasks: false,

            // deleting task
            deletingPlannedTask: { plant: {} },

            defaultItemsPerPage: 25,
            dataTableOptions: {},
            page: 1,
            search: "",

            headers: [
                {
                    text: "Start Date",
                    value: "node.startDate",
                    sortable: true
                },
                {
                    text: "End Date",
                    value: "node.endDate",
                    sortable: true
                },
                {
                    text: "Department",
                    value:
                        "node.greenhouseDepartmentSection.greenhouseDepartment.name",
                    sortable: true
                },
                {
                    text: "Sector",
                    value: "node.greenhouseDepartmentSection.name",
                    sortable: true
                },
                {
                    text: "Plant Species",
                    value: "node.plannedTask.plant.plantSpecies.name",
                    sortable: true
                },
                {
                    text: "Plant",
                    value: "node.plannedTask.plant.name",
                    sortable: true
                },
                {
                    text: "Pot Size",
                    value: "node.plannedTask.potSize.potSizeCm",
                    sortable: true
                },
                {
                    text: "Color",
                    align: "left",
                    value: "node.plannedTask.color.color",
                    sortable: true
                },
                {
                    text: "Environment",
                    value: "node.plannedTask.environment.environment",
                    sortable: true
                },
                {
                    text: "Tag",
                    value: "node.plannedTask.tag.tag",
                    sortable: true
                },
                {
                    text: "Supplier",
                    value: "node.plannedTask.supplier.name",
                    sortable: true
                },
                {
                    text: "Phase No",
                    value: "node.phaseNo",
                    sortable: true
                },
                {
                    text: "Quantity",
                    value: "node.plannedTask.quantity",
                    sortable: true,
                    align: "right"
                },
                {
                    text: "Space(m2)",
                    value: "node.spaceM2",
                    sortable: true,
                    align: "right"
                },
                {
                    text: "Actions",
                    value: "action",
                    width: "120px",
                    align: "center",
                    sortable: false
                },
                {
                    text: "Growth Task",
                    value: "node.plannedTask.isDone",
                    sortable: true
                }
            ]
        };
    },
    computed: {
        planFilterDepartmentList() {
            if (!this.tenantPlannedTaskPhases.edges) {
                return [];
            }

            const departments = [
                ...new Set(
                    this.tenantPlannedTaskPhases.edges.map(item => {
                        return {
                            node:
                                item.node.greenhouseDepartmentSection
                                    .greenhouseDepartment
                        };
                    })
                )
            ];

            return departments;
        },
        planFilterSectionList() {
            if (!this.tenantPlannedTaskPhases.edges) {
                return [];
            }

            const sections = [
                ...new Set(
                    this.tenantPlannedTaskPhases.edges.map(item => {
                        return { node: item.node.greenhouseDepartmentSection };
                    })
                )
            ];

            return sections;
        }
    },
    watch: {
        selectedGreenhouseDepartmentId() {
            this.getPlannedTaskPhases();
        },
        selectedGreenhouseDepartmentSectionId() {
            this.getPlannedTaskPhases();
        },
        selectedWeek() {
            this.getPlannedTaskPhases();
        },
        dataTableOptions: {
            handler() {
                this.$nextTick().then(() => {
                    this.getPlannedTaskPhases();
                });
            },
            deep: true
        }
    },
    created() {
        this.hasPermission = helper.hasPermission;
    },
    mounted() {
        this.$nextTick(() => {
            this.getPlannedTaskPhases();
        });
        // console.log(this.$vuetify.breakpoint.name);
    },
    methods: {
        getPlannedTaskPhases() {
            if (!this.selectedYear) {
                return;
            }

            // reset data table page to first page
            if (this.shouldResetDataTablePage) {
                this.dataTableOptions.page = 1;
            }

            const {
                sortBy,
                sortDesc,
                page,
                itemsPerPage
            } = this.dataTableOptions;

            var _first = itemsPerPage;
            var _last = null;
            var _before = null;
            var _after = null;
            var _orderBy = null;

            // console.log(page, this.page, this.shouldResetDataTablePage);

            if (!this.shouldResetDataTablePage && page < this.page) {
                _first = null;
                _last = itemsPerPage;
                _before = this.tenantPlannedTaskPhases.pageInfo.startCursor;
                _after = null;
            }

            if (!this.shouldResetDataTablePage && page > this.page) {
                _first = itemsPerPage;
                _last = null;
                _before = null;
                _after = this.tenantPlannedTaskPhases.pageInfo.endCursor;
            }

            switch (sortBy[0]) {
                case "node.startDate":
                    _orderBy = "startDate";
                    break;
                case "node.endDate":
                    _orderBy = "endDate";
                    break;
                case "node.greenhouseDepartmentSection.greenhouseDepartment.name":
                    _orderBy = "greenhouseDepartmentName";
                    break;
                case "node.greenhouseDepartmentSection.name":
                    _orderBy = "greenhouseDepartmentSectionName";
                    break;
                case "node.plannedTask.plant.plantSpecies.name":
                    _orderBy = "plantSpeciesName";
                    break;
                case "node.plannedTask.plant.name":
                    _orderBy = "plantName";
                    break;
                case "node.plannedTask.potSize.potSizeCm":
                    _orderBy = "potSize";
                    break;
                case "node.plannedTask.color.color":
                    _orderBy = "color";
                    break;
                case "node.plannedTask.environment.environment":
                    _orderBy = "environment";
                    break;
                case "node.plannedTask.tag.tag":
                    _orderBy = "tag";
                    break;
                case "node.plannedTask.supplier.name":
                    _orderBy = "supplierName";
                    break;
                case "node.plannedTask.quantity":
                    _orderBy = "quantity";
                    break;
                case "node.spaceM2":
                    _orderBy = "spaceM2";
                    break;
                case "node.phaseNo":
                    _orderBy = "phaseNo";
                    break;
                case "node.plannedTask.isDone":
                    _orderBy = "isDone";
                    break;
                default:
                    _orderBy = "startDate";
                    break;
            }

            if (sortDesc[0] === true) {
                _orderBy = "-" + _orderBy;
            }

            const _isDone = this.hideDoneTasks ? false : null;

            this.isLoadingPlannedTaskPhases = true;

            this.$apollo
                .query({
                    // Query
                    query: gql`
                        query tenantPlannedTaskPhases(
                            $first: Int
                            $last: Int
                            $before: String
                            $after: String
                            $orderBy: String
                            $search: String
                            $greenhouse_Id: ID
                            $greenhouseDepartment_Id: ID
                            $greenhouseDepartmentSection_Id: ID
                            $searchYear: Int
                            $searchWeek: Int
                            $phaseNo: Int
                            $isSalesPhase: Boolean
                            $plannedTask_IsDone: Boolean
                            $plannedTaskPlanFolderId: ID
                            $plannedTaskPlanFolderIdIsnull: Boolean
                        ) {
                            tenantPlannedTaskPhases(
                                first: $first
                                last: $last
                                before: $before
                                after: $after
                                orderBy: $orderBy
                                search: $search
                                greenhouseDepartmentSection_GreenhouseDepartment_Greenhouse_Id: $greenhouse_Id
                                greenhouseDepartmentSection_GreenhouseDepartment_Id: $greenhouseDepartment_Id
                                greenhouseDepartmentSection_Id: $greenhouseDepartmentSection_Id
                                searchYear: $searchYear
                                searchWeek: $searchWeek
                                phaseNo: $phaseNo
                                isSalesPhase: $isSalesPhase
                                plannedTask_IsDone: $plannedTask_IsDone
                                plannedTask_PlanFolder_Id: $plannedTaskPlanFolderId
                                plannedTask_PlanFolder_Id_Isnull: $plannedTaskPlanFolderIdIsnull
                            ) {
                                edgeCount
                                totalCount
                                pageInfo {
                                    startCursor
                                    endCursor
                                    hasPreviousPage
                                    hasNextPage
                                }
                                edges {
                                    node {
                                        id
                                        phaseNo
                                        isSalesPhase
                                        spaceM2
                                        startDate
                                        endDate
                                        numDays
                                        plannedTask {
                                            id
                                            rawId
                                            isDone
                                            quantity
                                            supplier {
                                                id
                                                name
                                            }
                                            plant {
                                                id
                                                name
                                                plantSpecies {
                                                    id
                                                    name
                                                }
                                            }
                                            potSize {
                                                id
                                                potSizeCm
                                            }
                                            color {
                                                id
                                                color
                                            }
                                            environment {
                                                id
                                                environment
                                            }
                                            tag {
                                                id
                                                tag
                                            }
                                        }
                                        greenhouseDepartmentSection {
                                            id
                                            name
                                            greenhouseDepartment {
                                                id
                                                name
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    `,
                    // Parameters
                    variables: {
                        first: _first,
                        last: _last,
                        before: _before,
                        after: _after,
                        orderBy: _orderBy,
                        search: this.search,
                        greenhouse_Id: this.selectedGreenhouse
                            ? this.selectedGreenhouse.id
                            : null,
                        greenhouseDepartment_Id: this
                            .selectedGreenhouseDepartmentId,
                        greenhouseDepartmentSection_Id: this
                            .selectedGreenhouseDepartmentSectionId,
                        searchYear: this.selectedYear,
                        searchWeek: this.selectedWeek,
                        phaseNo: this.selectedPhaseNo,
                        isSalesPhase: this.selectedIsSalePhase,
                        plannedTask_IsDone: _isDone,
                        plannedTaskPlanFolderId: this.selectedPlanFolderID,
                        plannedTaskPlanFolderIdIsnull:
                            this.selectedPlanFolderID == null &&
                            this.selectedPlanFolderName == "Default"
                                ? true
                                : false
                    },
                    fetchPolicy: "network-only"
                })
                .then(response => {
                    // Result
                    // console.log(response.data);
                    // console.log(response.data.updateSalesOrderNote.salesOrder.note);

                    this.tenantPlannedTaskPhases = {
                        ...response.data.tenantPlannedTaskPhases
                    };

                    this.tenantPlannedTaskPhases.edges.forEach(edge => {
                        if (
                            this.initSelectedYear != null &&
                            this.initSelectedWeek != null
                        ) {
                            const _endDate = new moment(edge.node.endDate);

                            edge.node = {
                                ...edge.node,
                                endInSelectedWeek:
                                    _endDate.year() * 100 + _endDate.week() <=
                                    this.initSelectedYear * 100 +
                                        this.initSelectedWeek
                            };
                        }
                    });

                    // update this.page
                    this.page = page;
                    //// prepare planFilterDepartmentList
                    // this.planFilterDepartmentList =
                    //     response.data.greenhouse.greenhouseDepartmentSet.edges;
                })
                .catch(error => {
                    // Error
                    console.error(error);
                })
                .finally(() => {
                    // this.isSavingOrderPrintStatus = false;
                    this.isLoadingPlannedTaskPhases = false;
                });
        },

        viewPlannedTask(plannedTask) {
            this.plannedTaskSpaceChartDialog = true;

            this.$refs.plannedTaskSpaceChartDialogRef.getPlannedTaskSpace(
                plannedTask.id
            );
        },

        editPlannedTask(plannedTask) {
            // this.editedPlannedTask = plannedTask;
            this.plannedTaskEditDialog = true;

            this.$refs.plannedTaskEditDialogRef.initializeEditingPlannedTask(
                plannedTask.id
            );
        },

        onDeletingPlannedTask(plannedTask) {
            this.deletingPlannedTask = plannedTask;
            this.deletePlannedTaskDialog = true;
        },

        deletePlannedTaskConfirmed(item) {
            const payload = {
                id: item.id
            };

            // console.log(payload);

            this.$store
                .dispatch("plannedTasks/deletePlannedTask", payload)
                .then(() => {
                    this.$emit("onPlannedTaskDeleted");

                    // show snackbar
                    const payload = {
                        color: "success",
                        message: `The plan is deleted!`
                    };
                    this.$store.dispatch("snackbar/showMessage", payload);

                    this.getPlannedTaskPhases();

                    // close delete dialog
                    this.deletePlannedTaskDialog = false;
                })
                .catch(error => {
                    console.log(error);

                    this.error = error.graphQLErrors[0].message;
                })
                .finally(() => {});
        },

        onPlannedTaskCreated() {
            // refetch greenhouse planned space
            this.$emit("onPlannedTaskCreated");

            this.getPlannedTaskPhases();
        },

        openCreateGrowthTaskFromPlannedTask(plannedTaskNodeId) {
            // console.log(plannedTaskNodeId);

            this.createGrowthTaskFromPlannedTaskDialog = true;

            this.$refs.createGrowthTaskFromPlannedTaskDialogRef.initializePlannedTask(
                plannedTaskNodeId
            );
        },

        onGrowthTaskCreated() {
            // if (this.toggleViewType == 0) {
            //     this.getGreenhouseDepartmentSet();
            // } else {
            //     this.getPlannedTaskPhases();
            // }
            this.getPlannedTaskPhases();
        },

        closePlannedTaskPhaseList() {
            this.tenantPlannedTaskPhases = {};
            this.$emit("onClosePlannedTaskPhaseList");
        },
        onSavePlanQuantity(plannedTask) {
            this.isLoadingPlannedTaskPhases = true;

            this.$apollo
                .mutate({
                    // Query
                    mutation: gql`
                        mutation updatePlannedTaskQuantity(
                            $input: UpdatePlannedTaskQuantityInput!
                        ) {
                            updatePlannedTaskQuantity(input: $input) {
                                plannedTask {
                                    id
                                    isDone
                                    numPhases
                                    quantity
                                    totalGrowthDays
                                    maxSalesDays
                                    supplier {
                                        id
                                        name
                                    }
                                    plant {
                                        id
                                        name
                                        plantSpecies {
                                            id
                                            name
                                        }
                                    }
                                    potSize {
                                        id
                                        potSizeCm
                                    }
                                    color {
                                        id
                                        color
                                    }
                                    environment {
                                        id
                                        environment
                                    }
                                    tag {
                                        id
                                        tag
                                    }
                                    plannedTaskPhaseSet {
                                        edges {
                                            node {
                                                id
                                                spaceM2
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    `,
                    // Parameters
                    variables: {
                        input: {
                            id: plannedTask.id,
                            quantity: plannedTask.quantity
                        }
                    }
                    // // Update the cache with the result
                    // // The query will be updated with the optimistic response
                    // // and then with the real result of the mutation
                    // update: (store, { data: { addTag } }) => {
                    //     // Read the data from our cache for this query.
                    //     const data = store.readQuery({ query: TAGS_QUERY });
                    //     // Add our tag from the mutation to the end
                    //     data.tags.push(addTag);
                    //     // Write our data back to the cache.
                    //     store.writeQuery({ query: TAGS_QUERY, data });
                    // },
                    // // Optimistic UI
                    // // Will be treated as a 'fake' result as soon as the request is made
                    // // so that the UI can react quickly and the user be happy
                    // optimisticResponse: {
                    //     __typename: "Mutation",
                    //     addTag: {
                    //         __typename: "Tag",
                    //         id: -1,
                    //         label: newTag
                    //     }
                    // }
                })
                .then(response => {
                    this.isLoadingPlannedTaskPhases = false;
                    // update plan list spaceM2
                    response.data.updatePlannedTaskQuantity.plannedTask.plannedTaskPhaseSet.edges.forEach(
                        item => {
                            let foundIndex = this.tenantPlannedTaskPhases.edges.findIndex(
                                x => x.node.id == item.node.id
                            );

                            if (foundIndex !== -1) {
                                this.tenantPlannedTaskPhases.edges[
                                    foundIndex
                                ].node.spaceM2 = item.node.spaceM2;
                            }
                        }
                    );

                    // show snackbar
                    const payload = {
                        color: "success",
                        message: `The plan is updated!`
                    };
                    this.$store.dispatch("snackbar/showMessage", payload);
                })
                .catch(error => {
                    this.isLoadingPlannedTaskPhases = false;

                    // Error
                    console.error(error);

                    // show snackbar
                    const payload = {
                        color: "error",
                        message: `Update plan failed!`
                    };
                    this.$store.dispatch("snackbar/showMessage", payload);
                })
                .finally(() => {
                    // this.isLoadingPlannedTaskPhases = false;
                    // setTimeout(() => {
                    //     //your code to be executed after 1 second
                    //     this.isLoadingPlannedTaskPhases = false;
                    // }, 1000);
                });
        },

        onClearSearch() {
            this.search = "";

            this.getPlannedTaskPhases();
        },

        onChangeHideDoneTasks() {
            this.getPlannedTaskPhases();
        }
    }
};
</script>